// 3rd Party
import PropTypes from 'prop-types';
import React, { useState } from 'react';

// Components
import { Div, H3, OCButton, P } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import { Text } from './styled-components';

// Other

// Component
const ProviderAboutText = ({ about, questionResponses }) => {
  const [expanded, setExpanded] = useState(false);

  const handleAboutExpandToggle = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <Text expanded={expanded}>
        {about 
          && (
            <P color={colors.slate} margin="10px 0">
              {about}
            </P>
          )
        }
        {questionResponses
          && questionResponses.map(questionResponse => (
            <Div key={questionResponse.id} margin="20px 0 0 0">
              <H3 color={colors.charcoal} fontWeight="300" margin="10px 0">
                {questionResponse.question.question}?
              </H3>
              <P color={colors.slate} margin="10px 0">
                {questionResponse.response}
              </P>
            </Div>
          ))}
      </Text>
      <OCButton
        color={colors.darkBlue}
        fontSize="12px"
        margin="20px 0 20px 0"
        onClick={handleAboutExpandToggle}
        padding="0"
        type="link"
        // The screen reader will read the complete text regardless of if the
        // paragraph is collapsed (since it's done with CSS)
        aria-hidden
      >
        VIEW {expanded ? 'LESS' : 'MORE'}
      </OCButton>
    </>
  );
};

ProviderAboutText.propTypes = {
  about: PropTypes.string,
  questionResponses: PropTypes.array,
};

export default ProviderAboutText;
